import { Alert, Container, Typography } from "@mui/material";

function WrongWay() {
  return (
    <Container sx={{ marginTop: 2 }}>
      <Alert variant="outlined" severity="error">
        <Typography></Typography>
        <h2>
          <b>Ups, algo salió mal</b>
        </h2>
        Quizás esta no es la forma de ingresar a esta página o por alguna otra razón se ha producido un error al intentar cargar la página. <br/>Por favor vuelve a intentarlo, pero no únicamente recargando la página, sino volviendo a seguir los pasos para llegar hasta aquí.
      </Alert>
    </Container>
  );
}

export { WrongWay };
